import { Dialog } from "@mui/material";
import { styled } from "@mui/system";
import CrossIcon from "src/icons/CrossIcon";
import ContainedButton from "src/components/common/ContainedButton";
import { useAuth } from "src/providers/AuthProvider";
import { trackEvent } from "src/Amplitude";
import { refreshAuthLogic } from "src/utils/tokenRefreshLogic";
import { useEffect } from "react";

const DialogWrapper = styled(Dialog)(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: "10px",
  background: "#FFF",

  "& .MuiDialog-container": {
    width: "100%",
  },
  "& .MuiDialog-paper": {
    borderRadius: "10px",
  },
}));

const HeaderWrapper = styled("div")(() => ({
  display: "flex",
  padding: "16px 20px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  alignSelf: "stretch",
  background: "#002035",
}));

const HeaderTitle = styled("div")(() => ({
  flex: "1 0 0",
  color: "#FFF",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "-0.4px",
}));

const HeaderIcon = styled("div")(() => ({
  display: "flex",
  width: "16px",
  height: "16px",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
}));

const ContentWrapper = styled("div")(() => ({
  display: "flex",
  padding: "24px 28px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "20px",
  alignSelf: "stretch",
}));

const BodyText = styled("div")(() => ({
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
}));

const ButtonRow = styled("div")(() => ({
  width: "100%",
  display: "flex",
  gap: "12px",
}));

interface LogoutToUpdateModalProps {
  open: boolean;
  onClose: () => void;
}

const LogoutToUpdateModal = (props: LogoutToUpdateModalProps) => {
  const { open, onClose } = props;
  const { logout } = useAuth();

  const handleLogout = async () => {
    trackEvent("Clicked logout to update", {}, "Onboarding");
    await logout();
  };

  // While modal open refetch refreshAuthLogic every 15 seconds
  useEffect(() => {
    if (open) {
      const interval = setInterval(() => {
        refreshAuthLogic();
      }, 15000);
      return () => clearInterval(interval);
    }
  }, [open]);

  return (
    <DialogWrapper open={open} onClose={onClose} sx={{ background: "rgba(0, 32, 53, 0.7)" }}>
      <HeaderWrapper>
        <HeaderTitle>Profile Update Available</HeaderTitle>
        <HeaderIcon onClick={onClose}>
          <CrossIcon color="#FFF" />
        </HeaderIcon>
      </HeaderWrapper>
      <ContentWrapper>
        <BodyText>
          Your profile has just been verified. Please log out and back in so we can update your
          account and unlock full access.
        </BodyText>
        <ButtonRow>
          <ContainedButton color="salmon" width="100%" height="46px" onClick={handleLogout}>
            Log out now
          </ContainedButton>
        </ButtonRow>
      </ContentWrapper>
    </DialogWrapper>
  );
};

export default LogoutToUpdateModal;
